import { render, staticRenderFns } from "./EnableMcBrands.vue?vue&type=template&id=65eb17be"
import script from "./EnableMcBrands.vue?vue&type=script&lang=js"
export * from "./EnableMcBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports